import { render, staticRenderFns } from "./DepartamentPermissions.vue?vue&type=template&id=5db27037"
import script from "./DepartamentPermissions.vue?vue&type=script&lang=js"
export * from "./DepartamentPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports